import { store } from '../../../../../resources/frontend/js/store';
import {getNextQuestion} from './get-next-question';
import getStepFromQuestion from './get-step-from-question';

// Move all answers of question into one generic object
// Will help us handle the data for putting together
// the advanced flow.
export const getAllAnswers = () => {
    const questions = store.state.quiz.questionsData;
    const allAnswers = [];

    questions.forEach((question, index) => {
        let answers = [];

        switch (question._info.type) {
            case 'range-slider':
                answers = [ ...question.answers, { next_question: { value: question.next_question.value }} ];
                break;
            case 'buttons':
            case 'select':
            case 'card':
            case 'quiz':
            case 'radio-button':
                answers = question.answers;
                break;
            case 'zipcode':
                answers = [ { next_question: { value: question.answer.next_question.value }} ];
                break;
            case 'checkbox':
            case 'textfield':
            case 'address-autocomplete':
                answers = [ { next_question: { value: question.next_question?.value || 'next_question' }} ];
                break;
            case 'toggle-picker':
                answers = [ { next_question: { value: question.right_option.next_question.value }}, { next_question: { value: question.left_option.next_question.value }} ];
                break;
            case 'buttons-with-image':
                if (question.options.select_multiple_buttons.value) {
                    answers = [ { next_question: { value: question.next_question.value }} ];
                } else {
                    answers = [ ...question.answers ];
                }
                break;
        }

        allAnswers[index] = {
            uuid: question._info.uuid || index + 1,
            answers: [],
        };

        const allQuestionAnswers = [];
        for (const answer of answers) {
            const nextQuestion = getNextQuestion(answer.next_question?.value || 'next_question', index + 1);
            const nextStep = getStepFromQuestion(nextQuestion);

            allQuestionAnswers.push({
                question: nextQuestion,
                step: nextStep,
            });
        }

        allAnswers[index].answers = [...new Map(allQuestionAnswers.map(item => [item.question, item])).values()];
    });

    return allAnswers;
};
